var map = {
	"./prism-abap.js": [
		90318,
		67114
	],
	"./prism-abap.min.js": [
		30720,
		47699
	],
	"./prism-abnf.js": [
		50151,
		41496
	],
	"./prism-abnf.min.js": [
		99465,
		54305
	],
	"./prism-actionscript.js": [
		72513,
		37710
	],
	"./prism-actionscript.min.js": [
		48835,
		50519
	],
	"./prism-ada.js": [
		40862,
		60508
	],
	"./prism-ada.min.js": [
		42512,
		73317
	],
	"./prism-agda.js": [
		77099,
		45282
	],
	"./prism-agda.min.js": [
		28805,
		58091
	],
	"./prism-al.js": [
		27849,
		82137
	],
	"./prism-al.min.js": [
		93707,
		69328
	],
	"./prism-antlr4.js": [
		71313,
		59339
	],
	"./prism-antlr4.min.js": [
		51731,
		46530
	],
	"./prism-apacheconf.js": [
		84716,
		84957
	],
	"./prism-apacheconf.min.js": [
		56062,
		72148
	],
	"./prism-apex.js": [
		67476,
		78351
	],
	"./prism-apex.min.js": [
		76422,
		65542
	],
	"./prism-apl.js": [
		76181,
		55553
	],
	"./prism-apl.min.js": [
		85439,
		91160
	],
	"./prism-applescript.js": [
		17185,
		29720
	],
	"./prism-applescript.min.js": [
		54019,
		94113
	],
	"./prism-aql.js": [
		36184,
		6922
	],
	"./prism-aql.min.js": [
		37010,
		35923
	],
	"./prism-arduino.js": [
		15026,
		316
	],
	"./prism-arduino.min.js": [
		80844,
		13125
	],
	"./prism-arff.js": [
		53487,
		25934
	],
	"./prism-arff.min.js": [
		5137,
		38743
	],
	"./prism-armasm.js": [
		18937,
		7888
	],
	"./prism-armasm.min.js": [
		16155,
		20697
	],
	"./prism-arturo.js": [
		28239,
		65155
	],
	"./prism-arturo.min.js": [
		71377,
		84570
	],
	"./prism-asciidoc.js": [
		46371,
		71761
	],
	"./prism-asciidoc.min.js": [
		4381,
		58952
	],
	"./prism-asm6502.js": [
		62694,
		67975
	],
	"./prism-asm6502.min.js": [
		45592,
		3582
	],
	"./prism-asmatmel.js": [
		13784,
		90773
	],
	"./prism-asmatmel.min.js": [
		71922,
		77964
	],
	"./prism-aspnet.js": [
		30559,
		75547
	],
	"./prism-aspnet.min.js": [
		53409,
		62738
	],
	"./prism-autohotkey.js": [
		10845,
		24890
	],
	"./prism-autohotkey.min.js": [
		80807,
		53891
	],
	"./prism-autoit.js": [
		9118,
		47688
	],
	"./prism-autoit.min.js": [
		81872,
		60497
	],
	"./prism-avisynth.js": [
		17224,
		21521
	],
	"./prism-avisynth.min.js": [
		28834,
		56711
	],
	"./prism-avro-idl.js": [
		25442,
		66700
	],
	"./prism-avro-idl.min.js": [
		6748,
		31093
	],
	"./prism-awk.js": [
		45167,
		51474
	],
	"./prism-awk.min.js": [
		6417,
		15867
	],
	"./prism-bash.js": [
		57022,
		8741
	],
	"./prism-bash.min.js": [
		53552,
		95932
	],
	"./prism-basic.js": [
		87336,
		34359
	],
	"./prism-basic.min.js": [
		92546,
		21550
	],
	"./prism-batch.js": [
		40990,
		89729
	],
	"./prism-batch.min.js": [
		32848,
		25336
	],
	"./prism-bbcode.js": [
		42493,
		31539
	],
	"./prism-bbcode.min.js": [
		24007,
		2538
	],
	"./prism-bbj.js": [
		35328,
		19133
	],
	"./prism-bbj.min.js": [
		13370,
		6324
	],
	"./prism-bicep.js": [
		65869,
		49796
	],
	"./prism-bicep.min.js": [
		72343,
		14189
	],
	"./prism-birb.js": [
		86061,
		43190
	],
	"./prism-birb.min.js": [
		2231,
		55999
	],
	"./prism-bison.js": [
		99669,
		46976
	],
	"./prism-bison.min.js": [
		10239,
		11369
	],
	"./prism-bnf.js": [
		22248,
		24178
	],
	"./prism-bnf.min.js": [
		83202,
		36987
	],
	"./prism-bqn.js": [
		45663,
		39404
	],
	"./prism-bqn.min.js": [
		94017,
		52213
	],
	"./prism-brainfuck.js": [
		29905,
		68879
	],
	"./prism-brainfuck.min.js": [
		64403,
		4486
	],
	"./prism-brightscript.js": [
		78575,
		91837
	],
	"./prism-brightscript.min.js": [
		50929,
		79028
	],
	"./prism-bro.js": [
		19011,
		14635
	],
	"./prism-bro.min.js": [
		92669,
		63093
	],
	"./prism-bsl.js": [
		79827,
		72665
	],
	"./prism-bsl.min.js": [
		31757,
		59856
	],
	"./prism-c.js": [
		50271,
		7063
	],
	"./prism-c.min.js": [
		81793,
		94254
	],
	"./prism-cfscript.js": [
		68762,
		86134
	],
	"./prism-cfscript.min.js": [
		17716,
		98943
	],
	"./prism-chaiscript.js": [
		65910,
		92740
	],
	"./prism-chaiscript.min.js": [
		22184,
		57133
	],
	"./prism-cil.js": [
		89262,
		67122
	],
	"./prism-cil.min.js": [
		6784,
		79931
	],
	"./prism-cilkc.js": [
		97512,
		89920
	],
	"./prism-cilkc.min.js": [
		58242,
		54313
	],
	"./prism-cilkcpp.js": [
		60000,
		7966
	],
	"./prism-cilkcpp.min.js": [
		91610,
		72359
	],
	"./prism-clike.js": [
		75624,
		53793
	],
	"./prism-clike.min.js": [
		54146,
		40984
	],
	"./prism-clojure.js": [
		70478,
		47187
	],
	"./prism-clojure.min.js": [
		63584,
		66602
	],
	"./prism-cmake.js": [
		72509,
		72805
	],
	"./prism-cmake.min.js": [
		38855,
		59996
	],
	"./prism-cobol.js": [
		80065,
		50007
	],
	"./prism-cobol.min.js": [
		38755,
		37198
	],
	"./prism-coffeescript.js": [
		44511,
		31961
	],
	"./prism-coffeescript.min.js": [
		68097,
		19152
	],
	"./prism-concurnas.js": [
		16574,
		13899
	],
	"./prism-concurnas.min.js": [
		53392,
		1090
	],
	"./prism-cooklang.js": [
		36340,
		88281
	],
	"./prism-cooklang.min.js": [
		49350,
		59120
	],
	"./prism-coq.js": [
		87123,
		84495
	],
	"./prism-coq.min.js": [
		67245,
		20102
	],
	"./prism-core.js": [
		71983,
		91101
	],
	"./prism-core.min.js": [
		35345,
		78292
	],
	"./prism-cpp.js": [
		72415,
		87155
	],
	"./prism-cpp.min.js": [
		95457,
		22922
	],
	"./prism-crystal.js": [
		11380,
		46240
	],
	"./prism-crystal.min.js": [
		58182,
		10633
	],
	"./prism-csharp.js": [
		5651,
		23442
	],
	"./prism-csharp.min.js": [
		68141,
		36251
	],
	"./prism-cshtml.js": [
		30019,
		49060
	],
	"./prism-cshtml.min.js": [
		30077,
		13453
	],
	"./prism-csp.js": [
		58160,
		42454
	],
	"./prism-csp.min.js": [
		25258,
		55263
	],
	"./prism-css-extras.js": [
		25365,
		19656
	],
	"./prism-css-extras.min.js": [
		20799,
		32465
	],
	"./prism-css.js": [
		91113,
		88993
	],
	"./prism-css.min.js": [
		70827,
		24600
	],
	"./prism-csv.js": [
		62630,
		30803
	],
	"./prism-csv.min.js": [
		33560,
		1802
	],
	"./prism-cue.js": [
		57193,
		8005
	],
	"./prism-cue.min.js": [
		67531,
		72815
	],
	"./prism-cypher.js": [
		53575,
		33623
	],
	"./prism-cypher.min.js": [
		76425,
		20814
	],
	"./prism-d.js": [
		27966,
		15577
	],
	"./prism-d.min.js": [
		37808,
		2768
	],
	"./prism-dart.js": [
		60869,
		21334
	],
	"./prism-dart.min.js": [
		47151,
		34143
	],
	"./prism-dataweave.js": [
		5372,
		44292
	],
	"./prism-dataweave.min.js": [
		79790,
		57101
	],
	"./prism-dax.js": [
		40555,
		50738
	],
	"./prism-dax.min.js": [
		19685,
		15131
	],
	"./prism-dhall.js": [
		45293,
		2739
	],
	"./prism-dhall.min.js": [
		65047,
		37929
	],
	"./prism-diff.js": [
		47839,
		43166
	],
	"./prism-diff.min.js": [
		98753,
		72327
	],
	"./prism-django.js": [
		62091,
		40503
	],
	"./prism-django.min.js": [
		62021,
		27694
	],
	"./prism-dns-zone-file.js": [
		21451,
		63301
	],
	"./prism-dns-zone-file.min.js": [
		23941,
		28111
	],
	"./prism-docker.js": [
		70568,
		37683
	],
	"./prism-docker.min.js": [
		24002,
		57098
	],
	"./prism-dot.js": [
		84497,
		44289
	],
	"./prism-dot.min.js": [
		71283,
		31480
	],
	"./prism-ebnf.js": [
		763,
		18671
	],
	"./prism-ebnf.min.js": [
		3285,
		54278
	],
	"./prism-editorconfig.js": [
		33959,
		72844
	],
	"./prism-editorconfig.min.js": [
		79465,
		85653
	],
	"./prism-eiffel.js": [
		39319,
		98462
	],
	"./prism-eiffel.min.js": [
		15353,
		62855
	],
	"./prism-ejs.js": [
		56258,
		53832
	],
	"./prism-ejs.min.js": [
		74460,
		66641
	],
	"./prism-elixir.js": [
		84051,
		79450
	],
	"./prism-elixir.min.js": [
		4077,
		60035
	],
	"./prism-elm.js": [
		76110,
		83236
	],
	"./prism-elm.min.js": [
		46912,
		47629
	],
	"./prism-erb.js": [
		57449,
		9069
	],
	"./prism-erb.min.js": [
		34507,
		44676
	],
	"./prism-erlang.js": [
		37099,
		50879
	],
	"./prism-erlang.min.js": [
		98277,
		38070
	],
	"./prism-etlua.js": [
		97595,
		6249
	],
	"./prism-etlua.min.js": [
		32757,
		41856
	],
	"./prism-excel-formula.js": [
		80130,
		31867
	],
	"./prism-excel-formula.min.js": [
		37148,
		19058
	],
	"./prism-factor.js": [
		61507,
		47093
	],
	"./prism-factor.min.js": [
		33533,
		34284
	],
	"./prism-false.js": [
		45629,
		41410
	],
	"./prism-false.min.js": [
		33479,
		54219
	],
	"./prism-firestore-security-rules.js": [
		59576,
		64208
	],
	"./prism-firestore-security-rules.min.js": [
		24466,
		77017
	],
	"./prism-flow.js": [
		13028,
		60422
	],
	"./prism-flow.min.js": [
		10998,
		73231
	],
	"./prism-fortran.js": [
		32048,
		67028
	],
	"./prism-fortran.min.js": [
		65610,
		79837
	],
	"./prism-fsharp.js": [
		47782,
		63242
	],
	"./prism-fsharp.min.js": [
		85944,
		92243
	],
	"./prism-ftl.js": [
		27308,
		48771
	],
	"./prism-ftl.min.js": [
		31998,
		36122
	],
	"./prism-gap.js": [
		76862,
		55377
	],
	"./prism-gap.min.js": [
		29072,
		42568
	],
	"./prism-gcode.js": [
		50530,
		51591
	],
	"./prism-gcode.min.js": [
		70684,
		38782
	],
	"./prism-gdscript.js": [
		59616,
		25973
	],
	"./prism-gdscript.min.js": [
		12634,
		61580
	],
	"./prism-gedcom.js": [
		6497,
		10747
	],
	"./prism-gedcom.min.js": [
		36547,
		46354
	],
	"./prism-gettext.js": [
		11441,
		92920
	],
	"./prism-gettext.min.js": [
		60147,
		5729
	],
	"./prism-gherkin.js": [
		12420,
		18538
	],
	"./prism-gherkin.min.js": [
		45910,
		82771
	],
	"./prism-git.js": [
		85818,
		11932
	],
	"./prism-git.min.js": [
		20148,
		24741
	],
	"./prism-glsl.js": [
		73980,
		89134
	],
	"./prism-glsl.min.js": [
		78766,
		1943
	],
	"./prism-gml.js": [
		36774,
		54736
	],
	"./prism-gml.min.js": [
		3032,
		67545
	],
	"./prism-gn.js": [
		56633,
		17784
	],
	"./prism-gn.min.js": [
		1147,
		30593
	],
	"./prism-go-module.js": [
		75955,
		43402
	],
	"./prism-go-module.min.js": [
		25965,
		23987
	],
	"./prism-go.js": [
		86378,
		36796
	],
	"./prism-go.min.js": [
		89348,
		49605
	],
	"./prism-gradle.js": [
		43523,
		13998
	],
	"./prism-gradle.min.js": [
		94525,
		26807
	],
	"./prism-graphql.js": [
		34619,
		95952
	],
	"./prism-graphql.min.js": [
		52949,
		8761
	],
	"./prism-groovy.js": [
		75538,
		89987
	],
	"./prism-groovy.min.js": [
		31276,
		60986
	],
	"./prism-haml.js": [
		40418,
		96593
	],
	"./prism-haml.min.js": [
		87548,
		83784
	],
	"./prism-handlebars.js": [
		43800,
		92807
	],
	"./prism-handlebars.min.js": [
		15282,
		79998
	],
	"./prism-haskell.js": [
		554,
		67189
	],
	"./prism-haskell.min.js": [
		74660,
		2796
	],
	"./prism-haxe.js": [
		3700,
		51963
	],
	"./prism-haxe.min.js": [
		55046,
		87570
	],
	"./prism-hcl.js": [
		55025,
		57646
	],
	"./prism-hcl.min.js": [
		50163,
		70455
	],
	"./prism-hlsl.js": [
		14023,
		32028
	],
	"./prism-hlsl.min.js": [
		60681,
		44837
	],
	"./prism-hoon.js": [
		47224,
		38634
	],
	"./prism-hoon.min.js": [
		91282,
		67635
	],
	"./prism-hpkp.js": [
		75839,
		61432
	],
	"./prism-hpkp.min.js": [
		19329,
		25825
	],
	"./prism-hsts.js": [
		79788,
		35814
	],
	"./prism-hsts.min.js": [
		79774,
		48623
	],
	"./prism-http.js": [
		24784,
		70201
	],
	"./prism-http.min.js": [
		28714,
		57392
	],
	"./prism-ichigojam.js": [
		86597,
		95819
	],
	"./prism-ichigojam.min.js": [
		37039,
		83010
	],
	"./prism-icon.js": [
		90237,
		73021
	],
	"./prism-icon.min.js": [
		33159,
		60212
	],
	"./prism-icu-message-format.js": [
		14487,
		66415
	],
	"./prism-icu-message-format.min.js": [
		55033,
		2022
	],
	"./prism-idris.js": [
		37723,
		92033
	],
	"./prism-idris.min.js": [
		76565,
		79224
	],
	"./prism-iecst.js": [
		36794,
		26212
	],
	"./prism-iecst.min.js": [
		48916,
		39021
	],
	"./prism-ignore.js": [
		8714,
		19606
	],
	"./prism-ignore.min.js": [
		91844,
		32415
	],
	"./prism-inform7.js": [
		48880,
		23392
	],
	"./prism-inform7.min.js": [
		17290,
		36201
	],
	"./prism-ini.js": [
		70824,
		49010
	],
	"./prism-ini.min.js": [
		74786,
		13403
	],
	"./prism-io.js": [
		17064,
		64236
	],
	"./prism-io.min.js": [
		78274,
		28629
	],
	"./prism-j.js": [
		54688,
		93711
	],
	"./prism-j.min.js": [
		62234,
		80902
	],
	"./prism-java.js": [
		96976,
		16669
	],
	"./prism-java.min.js": [
		86333,
		3860
	],
	"./prism-javadoc.js": [
		36852,
		91051
	],
	"./prism-javadoc.min.js": [
		19942,
		61890
	],
	"./prism-javadoclike.js": [
		35643,
		97497
	],
	"./prism-javadoclike.min.js": [
		94261,
		84688
	],
	"./prism-javascript.js": [
		25723,
		31895
	],
	"./prism-javascript.min.js": [
		12661,
		19086
	],
	"./prism-javastacktrace.js": [
		87881,
		61370
	],
	"./prism-javastacktrace.min.js": [
		4395,
		41955
	],
	"./prism-jexl.js": [
		4993,
		35752
	],
	"./prism-jexl.min.js": [
		89571,
		48561
	],
	"./prism-jolie.js": [
		3717,
		80382
	],
	"./prism-jolie.min.js": [
		87983,
		44775
	],
	"./prism-jq.js": [
		42177,
		54764
	],
	"./prism-jq.min.js": [
		28867,
		67573
	],
	"./prism-js-extras.js": [
		9799,
		39538
	],
	"./prism-js-extras.min.js": [
		76841,
		52347
	],
	"./prism-js-templates.js": [
		54029,
		45221
	],
	"./prism-js-templates.min.js": [
		10423,
		32412
	],
	"./prism-jsdoc.js": [
		16625,
		22423
	],
	"./prism-jsdoc.min.js": [
		72544,
		9614
	],
	"./prism-json.js": [
		72514,
		26209
	],
	"./prism-json.min.js": [
		13564,
		13400
	],
	"./prism-json5.js": [
		10267,
		19603
	],
	"./prism-json5.min.js": [
		78837,
		39018
	],
	"./prism-jsonp.js": [
		70696,
		7197
	],
	"./prism-jsonp.min.js": [
		44226,
		94388
	],
	"./prism-jsstacktrace.js": [
		52850,
		71104
	],
	"./prism-jsstacktrace.min.js": [
		4396,
		35497
	],
	"./prism-jsx.js": [
		65903,
		48306
	],
	"./prism-jsx.min.js": [
		85841,
		61115
	],
	"./prism-julia.js": [
		60463,
		90276
	],
	"./prism-julia.min.js": [
		19281,
		54669
	],
	"./prism-keepalived.js": [
		54054,
		67318
	],
	"./prism-keepalived.min.js": [
		44472,
		80127
	],
	"./prism-keyman.js": [
		54033,
		44520
	],
	"./prism-keyman.min.js": [
		35763,
		57329
	],
	"./prism-kotlin.js": [
		69913,
		38763
	],
	"./prism-kotlin.min.js": [
		42459,
		25954
	],
	"./prism-kumir.js": [
		62486,
		13145
	],
	"./prism-kumir.min.js": [
		36264,
		336
	],
	"./prism-kusto.js": [
		59102,
		9359
	],
	"./prism-kusto.min.js": [
		93968,
		44966
	],
	"./prism-latex.js": [
		25294,
		15965
	],
	"./prism-latex.min.js": [
		99008,
		3156
	],
	"./prism-latte.js": [
		84403,
		50752
	],
	"./prism-latte.min.js": [
		50266,
		47786
	],
	"./prism-less.js": [
		18713,
		88521
	],
	"./prism-less.min.js": [
		83643,
		75712
	],
	"./prism-lilypond.js": [
		74215,
		65723
	],
	"./prism-lilypond.min.js": [
		70761,
		1330
	],
	"./prism-linker-script.js": [
		95635,
		7693
	],
	"./prism-linker-script.min.js": [
		57965,
		94884
	],
	"./prism-liquid.js": [
		57936,
		84735
	],
	"./prism-liquid.min.js": [
		98954,
		49545
	],
	"./prism-lisp.js": [
		10116,
		26705
	],
	"./prism-lisp.min.js": [
		77174,
		97544
	],
	"./prism-livescript.js": [
		86545,
		3966
	],
	"./prism-livescript.min.js": [
		55667,
		68359
	],
	"./prism-llvm.js": [
		3801,
		78348
	],
	"./prism-llvm.min.js": [
		45179,
		91157
	],
	"./prism-log.js": [
		78160,
		84954
	],
	"./prism-log.min.js": [
		70346,
		65539
	],
	"./prism-lolcode.js": [
		75224,
		59336
	],
	"./prism-lolcode.min.js": [
		93938,
		72145
	],
	"./prism-lua.js": [
		80064,
		82134
	],
	"./prism-lua.min.js": [
		36890,
		94943
	],
	"./prism-magma.js": [
		66867,
		36307
	],
	"./prism-magma.min.js": [
		80749,
		7306
	],
	"./prism-makefile.js": [
		30260,
		94497
	],
	"./prism-makefile.min.js": [
		4006,
		30104
	],
	"./prism-markdown.js": [
		75545,
		39127
	],
	"./prism-markdown.min.js": [
		13467,
		26318
	],
	"./prism-markup-templating.js": [
		19700,
		13509
	],
	"./prism-markup-templating.min.js": [
		6726,
		700
	],
	"./prism-markup.js": [
		64312,
		98283
	],
	"./prism-markup.min.js": [
		4818,
		85474
	],
	"./prism-mata.js": [
		645,
		52456
	],
	"./prism-mata.min.js": [
		65807,
		65265
	],
	"./prism-matlab.js": [
		65961,
		29658
	],
	"./prism-matlab.min.js": [
		8747,
		58659
	],
	"./prism-maxscript.js": [
		32851,
		71468
	],
	"./prism-maxscript.min.js": [
		19053,
		35861
	],
	"./prism-mel.js": [
		60416,
		48670
	],
	"./prism-mel.min.js": [
		58490,
		61479
	],
	"./prism-mermaid.js": [
		4201,
		30624
	],
	"./prism-mermaid.min.js": [
		4651,
		43433
	],
	"./prism-metafont.js": [
		52220,
		31477
	],
	"./prism-metafont.min.js": [
		29518,
		67084
	],
	"./prism-mizar.js": [
		77185,
		57095
	],
	"./prism-mizar.min.js": [
		12515,
		44286
	],
	"./prism-mongodb.js": [
		86380,
		60881
	],
	"./prism-mongodb.min.js": [
		48606,
		48072
	],
	"./prism-monkey.js": [
		11621,
		54275
	],
	"./prism-monkey.min.js": [
		97327,
		25274
	],
	"./prism-moonscript.js": [
		71386,
		41869
	],
	"./prism-moonscript.min.js": [
		55668,
		29060
	],
	"./prism-n1ql.js": [
		79988,
		7690
	],
	"./prism-n1ql.min.js": [
		55974,
		88275
	],
	"./prism-n4js.js": [
		66449,
		82072
	],
	"./prism-n4js.min.js": [
		3347,
		94881
	],
	"./prism-nand2tetris-hdl.js": [
		9121,
		78286
	],
	"./prism-nand2tetris-hdl.min.js": [
		93443,
		91095
	],
	"./prism-naniscript.js": [
		48607,
		1084
	],
	"./prism-naniscript.min.js": [
		66401,
		36274
	],
	"./prism-nasm.js": [
		55877,
		85858
	],
	"./prism-nasm.min.js": [
		39279,
		98667
	],
	"./prism-neon.js": [
		5796,
		40031
	],
	"./prism-neon.min.js": [
		92982,
		27222
	],
	"./prism-nevod.js": [
		28904,
		98221
	],
	"./prism-nevod.min.js": [
		80770,
		33828
	],
	"./prism-nginx.js": [
		99486,
		21019
	],
	"./prism-nginx.min.js": [
		97712,
		8210
	],
	"./prism-nim.js": [
		37110,
		95401
	],
	"./prism-nim.min.js": [
		91816,
		31008
	],
	"./prism-nix.js": [
		35177,
		13447
	],
	"./prism-nix.min.js": [
		38955,
		49054
	],
	"./prism-nsis.js": [
		57787,
		56180
	],
	"./prism-nsis.min.js": [
		14773,
		68989
	],
	"./prism-objectivec.js": [
		20596,
		49574
	],
	"./prism-objectivec.min.js": [
		91014,
		62383
	],
	"./prism-ocaml.js": [
		39814,
		53360
	],
	"./prism-ocaml.min.js": [
		99896,
		66169
	],
	"./prism-odin.js": [
		52748,
		30562
	],
	"./prism-odin.min.js": [
		97822,
		43371
	],
	"./prism-opencl.js": [
		58415,
		45788
	],
	"./prism-opencl.min.js": [
		65681,
		58597
	],
	"./prism-openqasm.js": [
		88530,
		76529
	],
	"./prism-openqasm.min.js": [
		92460,
		63720
	],
	"./prism-oz.js": [
		13885,
		69923
	],
	"./prism-oz.min.js": [
		13063,
		89338
	],
	"./prism-parigp.js": [
		94741,
		95541
	],
	"./prism-parigp.min.js": [
		64927,
		82732
	],
	"./prism-parser.js": [
		27059,
		72743
	],
	"./prism-parser.min.js": [
		31117,
		8350
	],
	"./prism-pascal.js": [
		97376,
		54697
	],
	"./prism-pascal.min.js": [
		69914,
		90304
	],
	"./prism-pascaligo.js": [
		9427,
		8870
	],
	"./prism-pascaligo.min.js": [
		40493,
		21679
	],
	"./prism-pcaxis.js": [
		70736,
		15476
	],
	"./prism-pcaxis.min.js": [
		71690,
		28285
	],
	"./prism-peoplecode.js": [
		91166,
		89858
	],
	"./prism-peoplecode.min.js": [
		81808,
		2667
	],
	"./prism-perl.js": [
		32821,
		12656
	],
	"./prism-perl.min.js": [
		25247,
		25465
	],
	"./prism-php-extras.js": [
		55248,
		30702
	],
	"./prism-php-extras.min.js": [
		45610,
		43511
	],
	"./prism-php.js": [
		43554,
		50238
	],
	"./prism-php.min.js": [
		63484,
		63047
	],
	"./prism-phpdoc.js": [
		7506,
		73036
	],
	"./prism-phpdoc.min.js": [
		57868,
		37429
	],
	"./prism-plant-uml.js": [
		32580,
		31226
	],
	"./prism-plant-uml.min.js": [
		82070,
		60227
	],
	"./prism-plsql.js": [
		85106,
		54024
	],
	"./prism-plsql.min.js": [
		67852,
		66833
	],
	"./prism-powerquery.js": [
		97551,
		28406
	],
	"./prism-powerquery.min.js": [
		69393,
		41215
	],
	"./prism-powershell.js": [
		30905,
		62793
	],
	"./prism-powershell.min.js": [
		48955,
		98400
	],
	"./prism-processing.js": [
		14775,
		88411
	],
	"./prism-processing.min.js": [
		58425,
		75602
	],
	"./prism-prolog.js": [
		16167,
		65613
	],
	"./prism-prolog.min.js": [
		33609,
		1220
	],
	"./prism-promql.js": [
		24127,
		29804
	],
	"./prism-promql.min.js": [
		57185,
		94614
	],
	"./prism-properties.js": [
		41781,
		84625
	],
	"./prism-properties.min.js": [
		67839,
		71816
	],
	"./prism-protobuf.js": [
		39535,
		10376
	],
	"./prism-protobuf.min.js": [
		91633,
		39537
	],
	"./prism-psl.js": [
		54121,
		52346
	],
	"./prism-psl.min.js": [
		69387,
		16579
	],
	"./prism-pug.js": [
		28882,
		29388
	],
	"./prism-pug.min.js": [
		9196,
		42197
	],
	"./prism-puppet.js": [
		48214,
		71358
	],
	"./prism-puppet.min.js": [
		67176,
		35751
	],
	"./prism-pure.js": [
		86318,
		36960
	],
	"./prism-pure.min.js": [
		91136,
		1353
	],
	"./prism-purebasic.js": [
		32782,
		94227
	],
	"./prism-purebasic.min.js": [
		1536,
		13642
	],
	"./prism-purescript.js": [
		29405,
		833
	],
	"./prism-purescript.min.js": [
		2695,
		88024
	],
	"./prism-python.js": [
		52342,
		97047
	],
	"./prism-python.min.js": [
		26792,
		84238
	],
	"./prism-q.js": [
		84113,
		19845
	],
	"./prism-q.min.js": [
		65939,
		7036
	],
	"./prism-qml.js": [
		93732,
		4619
	],
	"./prism-qml.min.js": [
		36118,
		91810
	],
	"./prism-qore.js": [
		84709,
		70314
	],
	"./prism-qore.min.js": [
		16303,
		82963
	],
	"./prism-qsharp.js": [
		41329,
		93112
	],
	"./prism-qsharp.min.js": [
		6707,
		57505
	],
	"./prism-r.js": [
		27768,
		89326
	],
	"./prism-r.min.js": [
		87826,
		2135
	],
	"./prism-racket.js": [
		47702,
		63708
	],
	"./prism-racket.min.js": [
		20264,
		76517
	],
	"./prism-reason.js": [
		1396,
		48482
	],
	"./prism-reason.min.js": [
		32838,
		61291
	],
	"./prism-regex.js": [
		75133,
		37813
	],
	"./prism-regex.min.js": [
		68871,
		25004
	],
	"./prism-rego.js": [
		38383,
		31367
	],
	"./prism-rego.min.js": [
		10321,
		50622
	],
	"./prism-renpy.js": [
		60636,
		18801
	],
	"./prism-renpy.min.js": [
		7278,
		5992
	],
	"./prism-rescript.js": [
		19514,
		12195
	],
	"./prism-rescript.min.js": [
		6900,
		47962
	],
	"./prism-rest.js": [
		71806,
		16141
	],
	"./prism-rest.min.js": [
		48112,
		51748
	],
	"./prism-rip.js": [
		89309,
		30452
	],
	"./prism-rip.min.js": [
		97031,
		43261
	],
	"./prism-roboconf.js": [
		45714,
		72262
	],
	"./prism-roboconf.min.js": [
		12236,
		36655
	],
	"./prism-robotframework.js": [
		39860,
		27632
	],
	"./prism-robotframework.min.js": [
		13926,
		40441
	],
	"./prism-ruby.js": [
		41648,
		53250
	],
	"./prism-ruby.min.js": [
		96010,
		66059
	],
	"./prism-rust.js": [
		75342,
		68476
	],
	"./prism-rust.min.js": [
		78624,
		81285
	],
	"./prism-sas.js": [
		93391,
		2655
	],
	"./prism-sas.min.js": [
		52401,
		89846
	],
	"./prism-sass.js": [
		99562,
		9261
	],
	"./prism-sass.min.js": [
		9060,
		96452
	],
	"./prism-scala.js": [
		64252,
		83643
	],
	"./prism-scala.min.js": [
		45358,
		19250
	],
	"./prism-scheme.js": [
		14183,
		6441
	],
	"./prism-scheme.min.js": [
		22601,
		93632
	],
	"./prism-scss.js": [
		94604,
		24487
	],
	"./prism-scss.min.js": [
		96414,
		11678
	],
	"./prism-shell-session.js": [
		60061,
		15206
	],
	"./prism-shell-session.min.js": [
		63559,
		79599
	],
	"./prism-smali.js": [
		3842,
		73396
	],
	"./prism-smali.min.js": [
		82684,
		86205
	],
	"./prism-smalltalk.js": [
		18619,
		96194
	],
	"./prism-smalltalk.min.js": [
		17941,
		9003
	],
	"./prism-smarty.js": [
		99124,
		70576
	],
	"./prism-smarty.min.js": [
		92902,
		83385
	],
	"./prism-sml.js": [
		23466,
		88622
	],
	"./prism-sml.min.js": [
		96772,
		1431
	],
	"./prism-solidity.js": [
		43537,
		71217
	],
	"./prism-solidity.min.js": [
		85171,
		58408
	],
	"./prism-solution-file.js": [
		24686,
		64611
	],
	"./prism-solution-file.min.js": [
		94560,
		35610
	],
	"./prism-soy.js": [
		18731,
		41813
	],
	"./prism-soy.min.js": [
		94021,
		77420
	],
	"./prism-sparql.js": [
		70537,
		67431
	],
	"./prism-sparql.min.js": [
		80939,
		54622
	],
	"./prism-splunk-spl.js": [
		80371,
		49385
	],
	"./prism-splunk-spl.min.js": [
		9325,
		36576
	],
	"./prism-sqf.js": [
		85540,
		32623
	],
	"./prism-sqf.min.js": [
		47926,
		19814
	],
	"./prism-sql.js": [
		96966,
		55581
	],
	"./prism-sql.min.js": [
		39864,
		26420
	],
	"./prism-squirrel.js": [
		88191,
		13611
	],
	"./prism-squirrel.min.js": [
		93569,
		802
	],
	"./prism-stan.js": [
		79032,
		36409
	],
	"./prism-stan.min.js": [
		12626,
		23600
	],
	"./prism-stata.js": [
		76263,
		70807
	],
	"./prism-stata.min.js": [
		1129,
		41646
	],
	"./prism-stylus.js": [
		77382,
		65124
	],
	"./prism-stylus.min.js": [
		27064,
		77933
	],
	"./prism-supercollider.js": [
		95009,
		42166
	],
	"./prism-supercollider.min.js": [
		44579,
		71327
	],
	"./prism-swift.js": [
		54793,
		45952
	],
	"./prism-swift.min.js": [
		23243,
		75113
	],
	"./prism-systemd.js": [
		42237,
		87922
	],
	"./prism-systemd.min.js": [
		46791,
		52315
	],
	"./prism-t4-cs.js": [
		23119,
		3148
	],
	"./prism-t4-cs.min.js": [
		73521,
		67541
	],
	"./prism-t4-templating.js": [
		99948,
		84133
	],
	"./prism-t4-templating.min.js": [
		79230,
		71324
	],
	"./prism-t4-vb.js": [
		99717,
		61335
	],
	"./prism-t4-vb.min.js": [
		16879,
		48526
	],
	"./prism-tap.js": [
		50803,
		65121
	],
	"./prism-tap.min.js": [
		65037,
		52312
	],
	"./prism-tcl.js": [
		13645,
		58515
	],
	"./prism-tcl.min.js": [
		6071,
		77930
	],
	"./prism-textile.js": [
		64379,
		46109
	],
	"./prism-textile.min.js": [
		32309,
		33300
	],
	"./prism-toml.js": [
		70132,
		282
	],
	"./prism-toml.min.js": [
		11526,
		80867
	],
	"./prism-tremor.js": [
		99009,
		74664
	],
	"./prism-tremor.min.js": [
		33411,
		87473
	],
	"./prism-tsx.js": [
		82769,
		19294
	],
	"./prism-tsx.min.js": [
		54547,
		83687
	],
	"./prism-tt2.js": [
		18872,
		93676
	],
	"./prism-tt2.min.js": [
		18738,
		6485
	],
	"./prism-turtle.js": [
		9434,
		78450
	],
	"./prism-turtle.min.js": [
		40340,
		91259
	],
	"./prism-twig.js": [
		1369,
		28899
	],
	"./prism-twig.min.js": [
		50523,
		99898
	],
	"./prism-typescript.js": [
		59587,
		35505
	],
	"./prism-typescript.min.js": [
		28125,
		22696
	],
	"./prism-typoscript.js": [
		38689,
		31719
	],
	"./prism-typoscript.min.js": [
		20227,
		18910
	],
	"./prism-unrealscript.js": [
		36472,
		6101
	],
	"./prism-unrealscript.min.js": [
		54450,
		41708
	],
	"./prism-uorazor.js": [
		59574,
		13256
	],
	"./prism-uorazor.min.js": [
		20392,
		26482
	],
	"./prism-uri.js": [
		34248,
		56696
	],
	"./prism-uri.min.js": [
		94402,
		69505
	],
	"./prism-v.js": [
		44036,
		82314
	],
	"./prism-v.min.js": [
		41206,
		62899
	],
	"./prism-vala.js": [
		76410,
		75708
	],
	"./prism-vala.min.js": [
		6868,
		88517
	],
	"./prism-vbnet.js": [
		47501,
		52910
	],
	"./prism-vbnet.min.js": [
		89271,
		65719
	],
	"./prism-velocity.js": [
		38587,
		34864
	],
	"./prism-velocity.min.js": [
		74613,
		47673
	],
	"./prism-verilog.js": [
		71260,
		9113
	],
	"./prism-verilog.min.js": [
		8238,
		96304
	],
	"./prism-vhdl.js": [
		17822,
		57112
	],
	"./prism-vhdl.min.js": [
		10608,
		21922
	],
	"./prism-vim.js": [
		80046,
		11933
	],
	"./prism-vim.min.js": [
		57088,
		99124
	],
	"./prism-visual-basic.js": [
		88835,
		5327
	],
	"./prism-visual-basic.min.js": [
		51837,
		40934
	],
	"./prism-warpscript.js": [
		43037,
		30945
	],
	"./prism-warpscript.min.js": [
		13703,
		18136
	],
	"./prism-wasm.js": [
		28176,
		96558
	],
	"./prism-wasm.min.js": [
		12522,
		9367
	],
	"./prism-web-idl.js": [
		9274,
		70940
	],
	"./prism-web-idl.min.js": [
		68308,
		6130
	],
	"./prism-wgsl.js": [
		66473,
		77546
	],
	"./prism-wgsl.min.js": [
		24939,
		6547
	],
	"./prism-wiki.js": [
		18524,
		344
	],
	"./prism-wiki.min.js": [
		58094,
		87118
	],
	"./prism-wolfram.js": [
		65882,
		74726
	],
	"./prism-wolfram.min.js": [
		4756,
		87535
	],
	"./prism-wren.js": [
		85794,
		20631
	],
	"./prism-wren.min.js": [
		85404,
		7822
	],
	"./prism-xeora.js": [
		52639,
		43429
	],
	"./prism-xeora.min.js": [
		85569,
		30620
	],
	"./prism-xml-doc.js": [
		83960,
		17811
	],
	"./prism-xml-doc.min.js": [
		58226,
		37226
	],
	"./prism-xojo.js": [
		62742,
		24417
	],
	"./prism-xojo.min.js": [
		91592,
		11608
	],
	"./prism-xquery.js": [
		76108,
		98799
	],
	"./prism-xquery.min.js": [
		47902,
		34406
	],
	"./prism-yaml.js": [
		60083,
		52972
	],
	"./prism-yaml.min.js": [
		8653,
		65781
	],
	"./prism-yang.js": [
		18981,
		78590
	],
	"./prism-yang.min.js": [
		76687,
		42983
	],
	"./prism-zig.js": [
		15168,
		33960
	],
	"./prism-zig.min.js": [
		24410,
		46769
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35134;
module.exports = webpackAsyncContext;